"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUseSink = void 0;
const react_redux_1 = require("react-redux");
const react_1 = require("react");
const utils_1 = require("./utils");
function createUseSink(container) {
    return (sink, subscriber = true) => {
        if (subscriber) {
            const sinkPrototype = container.getSinkPrototype(sink);
            let storeState;
            if (typeof subscriber === 'function') {
                const subscribes = subscriber(sinkPrototype.stateNames);
                const subscribedStates = subscribes.map(key => react_redux_1.useSelector(state => state[sinkPrototype.namespace][key]));
                storeState = react_1.useMemo(() => utils_1.reduceKeys(subscribes, (_, index) => subscribedStates[index]), subscribedStates);
            }
            else {
                storeState = react_redux_1.useSelector(state => state[sinkPrototype.namespace]);
            }
            return react_1.useMemo(() => utils_1.mergeState(storeState, sinkPrototype.state, sinkPrototype.dispatches), [storeState, sinkPrototype]);
        }
        return container.getSink(sink);
    };
}
exports.createUseSink = createUseSink;
